import Vue from 'vue'
import * as $ from 'jquery'
import Fader from './components/Fader'
import FetchHtml from './components/FetchHtml'

const el = document.getElementById('where-wrapper')

if (el) {

  new Vue({
    el,
    name: 'WhereBox',
    components: {
      FetchHtml,
      'jb-fader': Fader,
    },
    data: {
      showWhereBox: true,
    },
    mounted() {
      this.$el.addEventListener('click', this.openLocator.bind(this))
    },
    methods: {
      shouldNotProceed (event) {
        return (
          !event.target.closest('.locator-trigger')
          || typeof window.jQuery !== 'function'
          || typeof window.jQuery.magnificPopup !== 'object'
        )
      },

      openLocator (event) {
        if ( this.shouldNotProceed(event) ) return
        event.preventDefault()
        this.showWhereBox = false
        $.magnificPopup.open({
          items: {
            src: '/lightbox-store-locator/',
          },
          type: 'iframe',
          iframe: {
            markup: `
              <div class="mfp-iframe-scaler">
                <div class="mfp-close"></div>
                <iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>
              </div>
            `
          },
          callbacks: {
            close: this.reset
          }
        })
      },

      reset () {
        // DOM elements are re-added
        // in order to restart its animation
        this.showWhereBox = true
      },
    },
  })

}



// WEBPACK FOOTER //
// ./sportspower/assets/es6/init-where-box.js